module.exports = __webpack_public_path__ + "static/img/logo.a64eb58f.png";